export default __webpack_public_path__ + "6b584728437d5fc45880ea08b18aafa6.png";